/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shopping_Clear_CheckedInputs */

const en_shopping_clear_checked = /** @type {(inputs: Shopping_Clear_CheckedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide checked items`)
};

const de_shopping_clear_checked = /** @type {(inputs: Shopping_Clear_CheckedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgehakte ausblenden`)
};

/**
* | output |
* | --- |
* | "Hide checked items" |
*
* @param {Shopping_Clear_CheckedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_clear_checked = /** @type {((inputs?: Shopping_Clear_CheckedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_Clear_CheckedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_clear_checked(inputs)
	return en_shopping_clear_checked(inputs)
});